import { UserService } from './../../services/userService/user.service';
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
  Renderer2,
  HostListener,
  DestroyRef,
  signal,
  computed,
  inject,
  QueryList,
  ViewChildren,
  viewChildren
} from '@angular/core';
import {
  Router, NavigationEnd
} from '@angular/router';
import {
  RoutingService
} from '../../services/routingService/routing.service';
import {
  StorageService
} from '../../services/storage.service';
import {
  NgbDropdownConfig, NgbModal, NgbModalRef
} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import * as download from 'downloadjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { HomePageFeedsService } from '../../services/homePageFeed/home-page-feeds.service';
import { ApiService } from '../../shared/ApiService/api.service';
import { CandidateService } from '../../services/candidate/candidate.service';
import { environment } from '../../../environments/environment';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { OpportunityService } from '../../services/opportunity.service';
import { asyncScheduler, combineLatest, concat, Observable, of, Subject } from 'rxjs';
import { HamburgerStateService } from '../hamburger-state.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Location } from '@angular/common';
declare var $: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('collapse', [
      state('open', style({
        opacity: '1',
        display: 'block',
        transform: 'translate3d(0, 0, 0)'
      })),
      state('closed', style({
        opacity: '0',
        display: 'none',
        transform: 'translate3d(100%,0, 0)'
      })),
      transition('closed => open', animate('200ms ease-in')),
      transition('open => closed', animate('100ms ease-out'))
    ])
  ],
  providers: [NgbDropdownConfig],
  standalone: false
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren('submenuToggle') submenuToggles!: QueryList<ElementRef>;
  @ViewChildren('submenuMenu') submenuMenus!: QueryList<ElementRef>;
  @ViewChildren('dropdownToggle') dropdownToggles!: QueryList<ElementRef>;
  @ViewChildren('dropdownMenu') dropdownMenus!: QueryList<ElementRef>;
  @ViewChild('nsdcNavMenu') nsdcNavMenu:ElementRef;
  menuOpenIndex = signal<number|null>(null);

  private hamburgerService = inject(HamburgerStateService);
  location = inject(Location);
  name: any;
  registerNumber: any;
  token: any;
  fileDataProfImg;
  candidateIs: Boolean = false;
  profileUpdateInfo: Boolean;
  showButton: Boolean = false;
  checkforRxpiredTokenVar: any;
  decode;
  subscription: any;
  showOption;
  userRole: any;
  showProfile;
  hideElement;
  show: Boolean = false;
  collapse: String = 'closed';
  casting: any;
  @ViewChild('loginpopup') private loginpopup: ElementRef;
  popUpContent: any;
  popUpTitle: any;
  advisModalRef: NgbModalRef;
  scheduleStartDate: any;
  scheduleEndDate: any;
  schedulePath: string;
  openMobileView: boolean;
  isSmallWindow = signal<boolean>(false);
  showMarquee: boolean = true;
  candidateJobSearchForm: UntypedFormGroup;
  opportunites: Observable<any>;
  opportunityInput = new Subject<string>();
  loadingOpportunities = false;
  isSearchOpen = false;
  menuData: any;
  isHamburgerOpen = computed(() => this.hamburgerService.isHamburger());
  isMobile = signal<boolean>(false);
  showSearchBoxInMobileView = signal<boolean>(false);
  buttons = this.hamburgerService.buttons;

  @ViewChild('searchSelect') searchSelect: ElementRef;
  public searchdModify = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    // if(scrollPosition===0){
    //   this.hideElement = false;
    // }

    this.showMarquee = scrollPosition === 0; // Hide when scrolling down, show when at top
  }
  isLoggedIn = computed(() => this.hamburgerService.isUserLoggedIn() );

  constructor(
    private router: RoutingService,
    config: NgbDropdownConfig,
    private route: Router,
    private storageService: StorageService,
    private userService: UserService,
    private candidate: CandidateService,
    private ref: ChangeDetectorRef,
    private candidateService: CandidateService,
    public toaster: ToastrService,
    private renderer: Renderer2,
    private modalService: NgbModal,
    private homeFeed: HomePageFeedsService,
    private advisoryModal: NgbModal,
    private apiService: ApiService,
    private fb: UntypedFormBuilder,
    private oppoService: OpportunityService,
    private service: HamburgerStateService,
    private breakPointObserver: BreakpointObserver,
    private destroyRef: DestroyRef,
    private routingService: RoutingService,

  ) {
    this.route.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url !== '/') {
          this.hideElement = true;
        } else {
          this.hideElement = false;
        }
      }
    });
    config.placement = 'bottom-right';
    config.autoClose = false;
    this.geCandidateDetails();
    this.subscription = this.candidateService.getProfileUpdateEmitter()
      .subscribe(item => this.getProfileImage());
    this.candidateJobSearchForm = this.fb.group({
      name: [null, Validators.compose([Validators.required])],
      state: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.menuData = this.hamburgerService.menuData;
    this.decode = this.router.decodeToken();
    this.hamburgerService.isUserLoggedIn.set(this.decode);
    this.loadOpportunities();
    this.getLoggedInUser().then(res => {
      this.getProfileImage();
      this.getDetailsOfCandidate();
    });
    this.route.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.candidateJobSearchForm.controls.name.setValue(null);
        this.ref.markForCheck();
      }
    });
    this.userService.runOnUserLoginChange(this.onLoginStateChange.bind(this));
    this.getAnnouncements();
    //To get the ScreenSize
    this.getScreenSize();
  }
  downloadFile(url) {
    download(url);
  }
  downloadpdf(url) {
    this.downloadFile(url)
  }
  getPublishedSchedule() {
    this.candidateService.getGrivanceActiveSchedule().subscribe(res => {
      if (res && res.data && res.data[0] && res.data[0].status === "completed" && res.data[0].gr_status === "published") {
        // let obj = {
        //   id:1234567,
        //   slug: "schedule-grivance-publish",
        //   status: "publish",
        //   type: "casting",
        //   custom_date:res.data[0].start_date,
        //   landing_page_url:res.data[0].schedule_path,
        //   link: "https://blog.apprenticeshipindia.gov.in/casting/inviting-public-comments-on-amendments-in-apprentices-act/",
        //   title: {
        //     rendered: "Schedule for AITT 111 Grievance Redressal"
        //   },
        //   content: {
        //     rendered: "<p>Schedule for AITT 111 Grievance Redressal</p>",
        //     protected: false
        //   },
        //   protected: false,
        //   template: "",
        //   popup: 'false',
        // }
        // this.casting.splice(0, 0, obj);
      }
    }, err => {
      console.log(err);
    })

    this.candidateService.getActiveSchedule().subscribe(res => {
      if (res && res.data && res.data[0]) {
        this.scheduleStartDate = res.data[0].start_date;
        this.scheduleEndDate = res.data[0].end_date;
        this.schedulePath = res.data[0].schedule_path;
        // let obj = {
        //   id:123456,
        //   slug: "schedule-publish",
        //   status: "publish",
        //   type: "casting",
        //   link: "https://blog.apprenticeshipindia.gov.in/casting/inviting-public-comments-on-amendments-in-apprentices-act/",
        //   title: {
        //     rendered: "Schedule for 111 ATS AITT"
        //   },
        //   content: {
        //     rendered: "<p>Schedule for 111 ATS AITT</p>",
        //     protected: false
        //   },
        //   protected: false,
        //   template: "",
        //   popup: 'false',
        // }
        // this.casting.splice(0, 0, obj);
      }
    }, err => {
      console.log(err);
    })

  }

  getSchedule() {
    window.open(this.schedulePath, '_blank');

    // this.candidateService.downloadActiveSchedule().subscribe(res => {
    //   console.log(res);
    //   window.open(res.data[0].schedule_path, '_blank');
    // }, err => {
    //   console.log(err)
    // })
  }

  toggleCollapse() {
    // this.show = !this.show;
    this.collapse = this.collapse == 'open' ? 'closed' : 'open';
    if (this.collapse == 'open') {
      this.renderer.addClass(document.body, 'disable-scroll');
    } else {
      this.renderer.removeClass(document.body, 'disable-scroll');
    }
  }
  toggleSearch(): void {
    this.isSearchOpen = !this.isSearchOpen;
  }

  geCandidateDetails() {
    this.candidateService.getProfile().subscribe(res => {
      if (this.storageService.getData('access_token')) {
        this.token = this.router.decodeToken();
        if (this.token.role === 'candidate') {
          if (res) {
            this.showButton = false;
          } else {
            this.showButton = true;
          }
        } else {
          this.showButton = false;
        }
      } else {
        this.showButton = false;
      }
    });
  }

  onLoginStateChange() {
    this.decode = this.router.decodeToken();
    this.hamburgerService.isUserLoggedIn.set(this.decode);
    this.getLoggedInUser().then(prm => {
      this.getProfileImage();
    });
    this.route.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.ref.markForCheck();
      }
    });
  }

  goToProfile() {
    this.router.nextStep();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  goTocandidateProfile() {
    if (this.storageService.getData('access_token')) {
      if (this.userRole === 'candidate') {
        this.route.navigate(['candidate/profile']);
      }
    }
  }

  changepassword() {
    this.route.navigate(['candidate/change-password']);
  }

  logOut() {
    this.userService.logOut().subscribe(() => {
      this.storageService.removeData('access_token');
      this.route.navigate(['/']);
      this.decode = null;
      this.showButton = false;
      this.ref.markForCheck();
      this.userService.onUserLoginStateChange();
      window.history.forward();
    });
  }

  gotoCompleteProfile() {
    this.route.navigate(['candidate/profile']);
  }

  private handleClick(event) {
    if (this.showOption) {
      const clickedComponent = event.target;
      if (clickedComponent !== this.loginpopup.nativeElement) {
        this.showOption = false;
      }
    }
  }

  // private toggleOption() {
  //   this.showOption = this.showOption === true ? false : true;
  // }

  getLoggedInUser() {
    return new Promise((resolve, reject) => {
      if (this.storageService.getData('access_token')) {
        this.userService.getLoggedInuserDetailsForHeader().subscribe(res => {
          this.name = res.name;
          this.userRole = res.role;
          if (res.role === 'candidate') {
            this.registerNumber = res['candidate']['code'] || '';
            this.candidateIs = true;
            const buttonDestiny = res['candidate']['is_activated'];
            if (buttonDestiny === false) {
              this.showButton = true;
            } else {
              this.showButton = false;
            }
          }
          return resolve(true);
        });
      }
    })
  }

  getDetailsOfCandidate() {
    const token:any = this.routingService.decodeToken();
    this.candidateService.candidateDetailsGet(token.sub).subscribe(res => {
      this.candidateService.setCandidateDetails(res['data']);
    });
  }

  getProfileImage() {

    if (this.storageService.getData('access_token')) {
      // this.userService.getLoggedInuserDetailsForHeader().subscribe(res => {
      //   this.name = res.name;
      // }, err => {
      //   console.log(err);
      // });
      this.candidate.candidateFilesGet(this.decode.sub, 'candidate', 'profile_image').subscribe(res => {
        this.fileDataProfImg = res['data']['filePath'];
        if (this.fileDataProfImg === '#') {
          this.fileDataProfImg = '';

        } else {

        }
      }, err => {
        console.log(err);
      });
    }
  }
  goTofeebasedLogin(id) {
    if (id === '1') {
      window.location.href = environment.btp_module;
    } else {
      window.location.href = environment.btp_module + '/direct-registration';
    }
  }

  melaRegistrationPage() {
    this.route.navigateByUrl('/mela-registration');
  }
  melaPage() {
    this.route.navigateByUrl('/pmnam-map');
  }

  initJqueryEvents() {
    $('.btns-profiles-sec').on('mouseenter', function () {
      $(this).find('ul').stop(true, true).fadeIn(200);
    });

    $('.btns-profiles-sec').on('mouseleave', function () {
      $(this).find('ul').stop(true, true).fadeOut(200);
    });
  }

  ngAfterViewInit(): void {
    this.checkForExpiredToken();
  
    this.dropdownToggles.forEach((toggleRef, index) => {
      const toggleEl = toggleRef.nativeElement as HTMLElement;
      const dropdownEl = this.dropdownMenus.toArray()[index].nativeElement as HTMLElement;
    
      const submenuEls = dropdownEl.querySelectorAll('.dropdown-submenu'); // Submenus under this dropdown
    
      // Mouse enter on toggle
      toggleEl.addEventListener('mousenter', () => {
        document.body.classList.add('naps-overflow-hidden');
        this.showAndAlignDropdown(dropdownEl);
      
      });
    
      // Mouse leave on toggle
      toggleEl.addEventListener('mouseleave', () => {
        if ( !dropdownEl.matches(':hover') && !Array.from(submenuEls).some(el => el.matches(':hover'))) {
          this.menuOpenIndex.set(null);
          console.log('mouseleave' ,index,toggleEl.matches(':hover'));
          this.ref.detectChanges();
          document.body.classList.remove('naps-overflow-hidden');
        }
      });
     
      // Mouse leave on dropdown
      dropdownEl.addEventListener('mouseleave', () => {
        asyncScheduler.schedule(()=>{
          if (!dropdownEl.matches(':hover') && !Array.from(submenuEls).some(el => el.matches(':hover'))) {
            this.menuOpenIndex.set(null);
            document.body.classList.remove('naps-overflow-hidden');
          }
        },200);
       
      });
    });
    
    this.bindSubmenuListeners();
    this.initJqueryEvents();
  }


  
  // Helper to show dropdown and align if needed
  private showAndAlignDropdown(dropdownEl: HTMLElement): void {
    dropdownEl.classList.remove('align-right');
    dropdownEl.classList.add('d-block');
    dropdownEl.style.visibility = 'hidden';
  
    requestAnimationFrame(() => {
      const rect = dropdownEl.getBoundingClientRect();
      if (rect.right > window.innerWidth) {
        dropdownEl.classList.add('align-right');
      }
  
      dropdownEl.classList.remove('d-block');
      dropdownEl.style.visibility = '';
    });
  }
  
  bindSubmenuListeners() {
    this.submenuToggles.forEach((toggleRef, index) => {
      const toggleEl = toggleRef.nativeElement as HTMLElement;
      const submenuWrapper = toggleEl.closest('.dropdown-submenu') as HTMLElement;
      const submenuEl = this.submenuMenus.toArray()[index].nativeElement as HTMLElement;
  
      let submenuHideTimeout: ReturnType<typeof setTimeout> | null = null;
  
      const clearHideTimeout = () => {
        if (submenuHideTimeout) {
          clearTimeout(submenuHideTimeout);
          submenuHideTimeout = null;
        }
      };
  
      const hideSubmenu = () => {
        submenuEl.classList.remove('show');
        submenuWrapper.classList.remove('open-left');
      };
  
      submenuWrapper.addEventListener('mouseover', (e) => {
        e.preventDefault();
        e.stopPropagation();
        clearHideTimeout();
  
        // Close all other submenus
        this.submenuMenus.forEach((menu, i) => {
          if (i !== index) {
            menu.nativeElement.classList.remove('show');
            menu.nativeElement.closest('.dropdown-submenu')?.classList.remove('open-left');
          }
        });
  
        submenuEl.classList.add('show');
  
        requestAnimationFrame(() => {
          const rect = submenuEl.getBoundingClientRect();
          submenuWrapper.classList.remove('open-left');
          if (rect.right > window.innerWidth) {
            submenuWrapper.classList.add('open-left');
          }
        });
      });
  
      // Leave from wrapper
      submenuWrapper.addEventListener('mouseleave', () => {
        submenuHideTimeout = setTimeout(() => {
          if (
            !submenuWrapper.matches(':hover') &&
            !submenuEl.matches(':hover')
          ) {
            hideSubmenu();
          }
        }, 300);
      });
  
      submenuEl.addEventListener('mouseover', clearHideTimeout);
      submenuEl.addEventListener('mouseleave', () => {
        submenuHideTimeout = setTimeout(() => {
          if (
            !submenuWrapper.matches(':hover') &&
            !submenuEl.matches(':hover')
          ) {
            hideSubmenu();
          }
        }, 300);
      });
    });
  }
  
  openMenu(index: number,open=true): void {
    asyncScheduler.schedule(()=>{
      this.menuOpenIndex.set(open ? index : null);
    });
  }
 

  checkForExpiredToken() {
    this.checkforRxpiredTokenVar = this.router.checkForExpiredToken();
    if (this.checkforRxpiredTokenVar === true) {
      setTimeout(() => {
        this.userService.logOut().subscribe(() => {
          this.toaster.error('Your session is expired');
          this.storageService.removeData('access_token');
          this.route.navigate(['/']);
          this.decode = null;
          this.hamburgerService.isUserLoggedIn.set(this.decode);
          this.showButton = false;
          this.ref.markForCheck();
        });
      }, 0);
    } else {
      return false;
    }
  }
  openVerticallyCentered(content?: any) {
    this.modalService.open(content, {
      centered: true,
      size: 'lg'
    });
  }
  openSbiPopUp(sbi?: any) {
    this.modalService.open(sbi, {
      centered: true,
      size: 'lg'
    });
  }
  getAnnouncements(): void {
    this.homeFeed.getCasting().subscribe(res => {
      this.casting = res;
      // this.getPublishedSchedule();
      // if (this.casting.length > 0) {
      //   this.showCasting = true;

      //   setTimeout(() => {
      //     this.renderer.setStyle(this.recentNotice.nativeElement, 'visibility', 'hidden');
      //     this.getSlickCasting();
      //     this.loadAltCast = false;
      //   }, 250);
      // }
    }, err => {
      console.log(err, 'ERRRR');
    });
  }

  openPopUp(content: any, castData: any, i: any): void {
    if (castData.id === 123456) {
      this.getSchedule();
      return;
    }
    this.casting.filter((temp) => {
      if (castData.id === temp.id) {
        this.popUpContent = castData['popup_content'];
        this.popUpTitle = castData['popup_title'];
        this.advisModalRef = this.advisoryModal.open(content, {
          windowClass: 'modal-holder',
          centered: true,
          size: 'lg',
          backdrop: 'static',
          keyboard: false
        });
        this.advisModalRef.result.then(res => {
          if (res === 'Close click') {
            this.advisModalRef.close();
            this.advisModalRef = null;
            // this.getSlickCasting();
          }
        }, err => {
          if (err === 'Cross click') {
            this.advisModalRef.close();
            this.advisModalRef = null;
          }
        });
      }
    });
  }

  openReportPopUp(report: any): void {
    this.modalService.open(report, {
      centered: true,
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    }).result.then(result => {
      if (result === 'Close click') {
      }
    }, err => {
      if (err === 'Cross click') {
      }
    });
  }


  getScreenSize() {
    const max992$ = this.breakPointObserver.observe(['(max-width: 992px)']);
    const max580$ = this.breakPointObserver.observe(['(max-width: 580px)']);

    combineLatest([max992$, max580$])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([bp992, bp580]) => {
        this.isSmallWindow.set(bp992.matches);
        this.isMobile.set(bp580.matches);
      });

  }

  onMenuIcon() {
    this.toggleState();
    if (this.isSmallWindow()) {
      this.openMobileView = !this.openMobileView;
    }
  }
  onSidenavClose(event) {
    this.openMobileView = event;
  }

  submitSearch() {
    if (this.candidateJobSearchForm.value.name) {
      this.oppoService.keyWord = this.candidateJobSearchForm.value.name;
      this.showSearchBoxInMobileView.set(false);
      const basePath = this.isLoggedIn() ? '/candidate/apprenticeship/opportunity' : '/apprenticeship/opportunity';
      this.route.navigateByUrl(basePath);
    }
  }

  updateSerachField(eve): void {
    if (eve.type === 'blur') {
      this.searchdModify = false;
    }
  }
  updateSearch(eve): void {
    if (eve) {
      this.searchdModify = false;
      this.submitSearch();
    }
  }
  updateSearchClose(eve): void {
    this.searchdModify = false;
  }
  updateSerachFields(eve): void {
    if (eve.type === 'focus') {
      this.searchdModify = true;
    }
  }

  private loadOpportunities() {
    this.opportunites = concat(
      of([]), // default items
      this.opportunityInput.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        tap(() => this.loadingOpportunities = true),
        switchMap(
          (term) => {
            let trimTerm = term?.trim();
            if (!trimTerm) {
              this.loadingOpportunities = false
              return of([]);
            }
            return this.candidateService.getTradePrefList(term).pipe(
              map(res => {
                return res;
              }),
              catchError(() => of([])), // empty list on error
              tap(() => this.loadingOpportunities = false)
            )
          })
      )
    );
  }

  toggleState() {
    this.service.isHamburger.set(!this.service.isHamburger());
  }
}

